import { FC, useEffect } from 'react';
import NProgress from 'nprogress';
import { Box, CircularProgress } from '@mui/material';

import './SuspenseLoader.scss';

type Props = {
  isFullScreen?: boolean;
};

const SuspenseLoader: FC<Props> = ({ isFullScreen = true }): JSX.Element => {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <Box
      //sx={style}
      display="flex"
      alignItems="center"
      justifyContent="center"
      className={'suspense-loader' + (isFullScreen ? ' fullscreen-loader' : '')}
    >
      <CircularProgress size={64} disableShrink thickness={3} />
    </Box>
  );
};

export default SuspenseLoader;
